import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Terms.module.css";

export const Terms = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the title based on the current path
  let type = "Terms";
  if (location.pathname === "/privacy-policy") {
    type = "Privacy Policy";
  } else if (location.pathname === "/terms") {
    type = "Terms of Service";
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.row}>
        <h1 className={styles.title}>{type}</h1>
        <button className={styles.close} onClick={() => navigate(-1)}>
          &#x2715;
        </button>
      </div>

      <p className={styles.sectionText}>Last updated September 24th, 2025</p>

      <h2 className={styles.sectionTitle}>1. INTRODUCTION</h2>
      <p className={styles.sectionText}>
        Welcome to Leetly, operated by Origin Apps ("Company," "we," "us," or
        "our"). Your learning journey and career success are important to us.
        This {type} explains how we collect, use, and protect your information
        when you use our mobile application, website, and any related services
        (collectively, the "Services").
      </p>
      <p className={styles.sectionText}>
        By using Leetly, you agree to the terms of this {type}. If you do not
        agree, please refrain from using our Services.
      </p>

      <h2 className={styles.sectionTitle}>2. INFORMATION WE COLLECT</h2>
      <p className={styles.sectionText}>
        At Leetly, we respect your privacy and are committed to ensuring your
        data is protected. Here's what we collect:
      </p>
      <p className={styles.sectionText}>
        • Learning Progress Data: Information about your coding practice,
        algorithm mastery progress, problem-solving patterns, and learning goals
        to provide personalized educational support.
      </p>
      <p className={styles.sectionText}>
        • Usage Data: Information about how you interact with our app, including
        problems solved, learning modules completed, mock interviews taken, and
        feature engagement.
      </p>
      <p className={styles.sectionText}>
        • Analytics Data: With your explicit consent, we may collect anonymized
        usage data (e.g., app performance metrics) to improve our Services.
      </p>
      <p className={styles.sectionText}>
        What We Don't Collect: We do not collect or store any payment details.
        All payment transactions are securely handled by third-party payment
        processors.
      </p>

      <h2 className={styles.sectionTitle}>3. HOW WE USE YOUR INFORMATION</h2>
      <p className={styles.sectionText}>
        We use the information you provide solely for the following purposes:
      </p>
      <p className={styles.sectionText}>
        • To provide personalized coding education and track your progress
        through your journey to mastering data structures and algorithms.
      </p>
      <p className={styles.sectionText}>
        • To deliver relevant coding problems, learning modules, and interview
        preparation content based on your skill level and learning goals.
      </p>
      <p className={styles.sectionText}>
        • To analyze anonymized usage trends and ensure the stability and
        effectiveness of our Services.
      </p>
      <p className={styles.sectionText}>
        • To provide educational support features like hints and explanations
        when you encounter challenging coding problems.
      </p>

      <h2 className={styles.sectionTitle}>4. EDUCATIONAL DISCLAIMER</h2>
      <p className={styles.sectionText}>
        Leetly is designed to support your coding education and interview
        preparation but is not a substitute for formal computer science
        education or professional career counseling. The app provides
        educational content, coding problems, and learning strategies to help
        you improve your programming skills.
      </p>
      <p className={styles.sectionText}>
        By using our Services, you understand and agree that Origin Apps is not
        liable for any career outcomes or job placement results. While we
        provide quality educational content, success in technical interviews
        depends on many factors beyond our app. Users should supplement their
        learning with additional resources and may benefit from formal
        education, mentorship, or career counseling services.
      </p>

      <h2 className={styles.sectionTitle}>5. USER RESPONSIBILITIES</h2>
      <p className={styles.sectionText}>By using Leetly, you agree to:</p>
      <p className={styles.sectionText}>
        • Use the app for lawful educational purposes and personal learning
        only.
      </p>
      <p className={styles.sectionText}>
        • Use the app as a supplement to, not replacement for, formal computer
        science education or professional career guidance when needed.
      </p>
      <p className={styles.sectionText}>
        • Not share your account credentials with others.
      </p>
      <p className={styles.sectionText}>
        • Use the app responsibly and understand that coding interview success
        requires practice beyond what any single app can provide.
      </p>
    </div>
  );
};

export default Terms;
